<template>
  <div id="contenedor-obras-solicitudes-configuracion-firma-desktop">
    <v-data-table
      :headers="headers"
      :items="listado">
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :firma="item"></opciones>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Opciones from '@/views/administracion/obrassolicitudes/configuracion/firmas/listado/Opciones.vue';

export default {
  name: 'ObrasSolicitudesConfiguracionFirmasDesktop',
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
      headers: [
        {
          text: 'Orden',
          align: 'start',
          sortable: false,
          value: 'orden',
          width: '1%',
        },
        { text: 'Funcionario', sortable: false, value: 'funcionario.nombre' },
        { text: '', sortable: false, value: 'acciones' },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
